import { Instance, types } from 'mobx-state-tree';

export const MeoCartItem = types
  .model({
    name: types.string,
    partNumber: types.string,
    price: types.number,
    itemPV: types.number,
    quantity: types.number
  })
  .named('MeoCartItem');

export type MeoCartItem = Instance<typeof MeoCartItem>;
